import { call, put, takeEvery } from 'redux-saga/effects'
import { userLaboratoryLogin, userLaboratoryLoginSuccess, userLaboratoryLoginFailed } from './slice'
import { API } from 'src/laboratory/services/index'

function* loginLaboratory({ payload }) {
  try {
    const response = yield call(API.authApi.loginApiLaboratory, payload)
    if (
      response?.status === 200 &&
      response?.data &&
      response?.data?.code === 0 &&
      response?.data?.error === false
    ) {
      yield put(userLaboratoryLoginSuccess({ payload: response?.data }))
    } else {
      yield put(userLaboratoryLoginFailed({ message: response?.data?.message }))
    }
  } catch (error) {
    yield put(userLaboratoryLoginFailed({ message: error?.message }))
  }
}

function* authSaga() {
  yield takeEvery(userLaboratoryLogin, loginLaboratory)
}

export default authSaga
